// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"HZ-z","colorTextValue":"IZ-z","swatches":"JZ-z","collapseLink":"KZ-z","isCollapsed":"LZ-z","dropdown":"MZ-z","disabled":"NZ-z"};